import Enum from 'enum'

export const Locales = new Enum({
  zh: "Chinese, Simplified (ZH_HANS)",
  hr: "Croatian (HR)",
  da: "Danish (DK)",
  nl: "Dutch (NL)",
  en: "English (EN)",
  et: "Estonian (ET)",
  fi: "Finnish (FI)",
  fr: "French (FR)",
  ka: "Georgian (KA)",
  de: "German (DE)",
  "de-DE-formal": "German (DE-formal)",
  hi: "Hindi (HI)",
  hu: "Hungarian (HU)",
  is: "Icelandic (IS)",
  it: "Italian (IT)",
  ja: "Japanese (JA)",
  ko: "Korean (KR)",
  nb: "Norwegian (NO)",
  pl: "Polish (PL)",
  pt: "Portuguese (PT)",
  "pt-BR": "Portuguese (BR)",
  ro: "Romanian (RO)",
  ru: "Russian (RU)",
  sr: "Serbian (SP)",
  sl: "Slovene (SI)",
  es: "Spanish (ES)",
  sv: "Swedish (SV)",
  th: "Thai (TH)",
  tr: "Turkish (TR)",
  vi: "Vietnamese (VN)",
})

export const LOCALE_OPTIONS = _.map(Locales.enums, (locale) => ({
  label: locale.value,
  value: locale.key,
}))



// WEBPACK FOOTER //
// ./src/scripts/components/I18n/Constants.js